import { type SkinPageConfig, templates } from '@nosinovacao/nosid-mfe-common';
import { type ErrorComponentProps } from '@tanstack/react-router';
import { ErrorLightPage, ErrorLightRoot, ErrorLightSidePanel } from './error.light';
import { ErrorWooPage, ErrorWooRoot, ErrorWooSidePanel } from './error.woo';
import { ErrorWooDarkPage, ErrorWooDarkRoot, ErrorWooDarkSidePanel } from './error.woo-dark';

export function ErrorRoot(props: Readonly<ErrorComponentProps>) {
  return templates.getSkinSelector(skinSelectorRoot(props));
}
function skinSelectorRoot(props: ErrorComponentProps): SkinPageConfig {
  return {
    skins: [
      {
        selector: 'isWooTvTemplate',
        component: <ErrorWooDarkRoot {...props} />,
      },
      {
        selector: 'isWooTemplate',
        component: <ErrorWooRoot {...props} />,
      },
    ],
    defaultValue: <ErrorLightRoot {...props} />,
  };
}

export function ErrorPage(props: Readonly<ErrorComponentProps>) {
  return templates.getSkinSelector(skinSelectorPage(props));
}
function skinSelectorPage(props: ErrorComponentProps): SkinPageConfig {
  return {
    skins: [
      {
        selector: 'isWooTvTemplate',
        component: <ErrorWooDarkPage {...props} />,
      },
      {
        selector: 'isWooTemplate',
        component: <ErrorWooPage {...props} />,
      },
    ],
    defaultValue: <ErrorLightPage {...props} />,
  };
}

export function ErrorSidePanel(props: Readonly<ErrorComponentProps>) {
  return templates.getSkinSelector(skinSelectorSidePanel(props));
}
function skinSelectorSidePanel(props: ErrorComponentProps): SkinPageConfig {
  return {
    skins: [
      {
        selector: 'isWooTvTemplate',
        component: <ErrorWooDarkSidePanel {...props} />,
      },
      {
        selector: 'isWooTemplate',
        component: <ErrorWooSidePanel {...props} />,
      },
    ],
    defaultValue: <ErrorLightSidePanel {...props} />,
  };
}
